import { render, staticRenderFns } from "./TablePaginatedManagers.vue?vue&type=template&id=49a3ec5b&scoped=true"
import script from "./TablePaginatedManagers.vue?vue&type=script&lang=js"
export * from "./TablePaginatedManagers.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedManagers.vue?vue&type=style&index=0&id=49a3ec5b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a3ec5b",
  null
  
)

export default component.exports